define('TescoMobile_Checkout/js/action/get-card-payment',['jquery', 'mage/storage', 'Magento_Checkout/js/model/url-builder', 'Magento_Checkout/js/model/quote', 'Magento_Customer/js/model/customer'], function ($, storage, urlBuilder, quote, customer) {
  'use strict';

  return function () {
    let version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let serviceUrl;
    if (version) {
      const initVersion = urlBuilder.version;
      urlBuilder.version = version;
      version = initVersion;
    } else {
      version = urlBuilder.version;
    }
    if (customer.isLoggedIn()) {
      serviceUrl = urlBuilder.createUrl('/carts/mine/card-payment', {});
    } else {
      serviceUrl = urlBuilder.createUrl('/guest-carts/:cartId/card-payment', {
        cartId: quote.getQuoteId()
      });
    }
    urlBuilder.version = version;
    return storage.get(serviceUrl);
  };
});

